var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrositelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pie-chart_1_",
    "data-name": "pie-chart (1)",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18990",
    "data-name": "Group 18990",
    transform: "translate(10.555 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18989",
    "data-name": "Group 18989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18170",
    "data-name": "Path 18170",
    d: "M272.465,0A.465.465,0,0,0,272,.465V7.011a.465.465,0,0,0,.465.465h6.515a.465.465,0,0,0,.465-.465A7.014,7.014,0,0,0,272.465,0Z",
    transform: "translate(-272)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18992",
    "data-name": "Group 18992",
    transform: "translate(0 2.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18991",
    "data-name": "Group 18991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18171",
    "data-name": "Path 18171",
    d: "M11.381,76.766,8.75,69.4v-7.83A.555.555,0,0,0,8.207,61a8.524,8.524,0,0,0,0,17.036,7.788,7.788,0,0,0,2.857-.541A.575.575,0,0,0,11.381,76.766Z",
    transform: "translate(0 -61)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18994",
    "data-name": "Group 18994",
    transform: "translate(10.554 10.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18993",
    "data-name": "Group 18993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18172",
    "data-name": "Path 18172",
    d: "M278.977,271h-6.515a.465.465,0,0,0-.436.629l2.288,6.131a.466.466,0,0,0,.6.272,7.06,7.06,0,0,0,4.528-6.567A.465.465,0,0,0,278.977,271Z",
    transform: "translate(-271.997 -271)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrositelogo);
export default __webpack_public_path__ + "static/media/micrositelogo.821582dd3907406218cd6557fc894988.svg";
export { ForwardRef as ReactComponent };